/**
 * Istemci kayit kimligi ureticisi.
 * `crypto.randomUUID` her modern tarayicida var; guvenli baglam disinda
 * (http) yoksa geri donus uretilir.
 */
export function kimlikUret(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `k-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
